__turbopack_context__.v({
  "card": "_6V3fMW_card",
  "card-list": "_6V3fMW_card-list",
  "card-list-item": "_6V3fMW_card-list-item",
  "founders-image": "_6V3fMW_founders-image",
  "hero": "_6V3fMW_hero",
  "split-layout": "_6V3fMW_split-layout",
});
